<script>
  import { onMount } from 'svelte';

  const key = '6LeIB3kiAAAAAAyLLaeJpRxjdVNLkNzzvHMJU2R1';
  let State = {
    idle: 'idle',
    requesting: 'requesting',
    success: 'success',
  };
  let token;
  let state = State.idle;

  onMount(async () => {
    window.grecaptcha.ready(() => {
      grecaptcha.render('recaptcha-id', { sitekey: key });
    });
  });

  function onSubmit() {
    state = State.requesting;
    if (doRecaptcha()) {
      console.log('captcha ok');
    } else {
      console.log('captcha nop');
    }
  }

  function doRecaptcha() {
    grecaptcha.ready(function () {
      grecaptcha.execute(key, { action: 'submit' }).then(function (t) {
        // state = State.success;
        // token = t;
        if ('success' == State.success) return true;
        return false;
      });
    });
  }
</script>

<svelte:head>
  <script
    src="https://www.google.com/recaptcha/api.js?render={key}"
    async
    defer
  ></script>
</svelte:head>

<div>state: {state}</div>
token:<br />{token}

<main>
  <form on:submit|preventDefault="{onSubmit}">
    <div id="recaptcha-id"></div>
    <button type="submit">submit</button>
  </form>
</main>

<style>
  main {
    font-family: sans-serif;
    text-align: center;
  }
</style>
